import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
	providedIn: 'root'
})
export class CryptService {

	passwordFromUI: string = ""
	constructor() {	}

	resetPassword() {
		this.passwordFromUI = Math.random().toString(36).slice(-10);
		// console.log('TOKEN PASS ', this.passwordFromUI);
		localStorage.setItem("eA20", this.passwordFromUI)
	}

	encrypt(request: any) {
		let eA20 = localStorage.getItem('eA20')
		let _key = eA20;
		let _iv = CryptoJS.enc.Utf8.parse(eA20);
		let encrypted = CryptoJS.AES.encrypt(request, _key);
		return encrypted.toString();
	}

	decrypt(encrypted) {
		let eA20 = localStorage.getItem('eA20')
		let _key = eA20;
		let _iv = CryptoJS.enc.Utf8.parse(eA20);
		let _decrypted = CryptoJS.AES.decrypt(encrypted, _key)
		return _decrypted.toString(CryptoJS.enc.Utf8);
	}

}
